<template>
  <div class="container">
    <el-button type="text" size="mini" @click="queryPublishMachine"
      >查看发布</el-button
    >
    <el-dialog
      title="此模块被发布的机器"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      width="600"
    >
      <el-row :gutter="10" style="text-align: left; padding: 10px">
        <el-input
          size="mini"
          style="width: 120px"
          v-model="searchBox"
          placeholder="搜索"
        ></el-input>
        <el-badge class="mark" :value="_machine_uuid_list.length || 0">
          <el-tag type="success" size="mini">总计</el-tag>
        </el-badge>
      </el-row>
      <vueVirtualTable
        :min-width="0"
        :config="tableConfig"
        :data="_machine_uuid_list"
      >
      </vueVirtualTable>
      <!--<span slot="footer" class="dialog-footer">-->
        <!--<el-button @click="dialogVisible = false">取 消</el-button>-->
        <!--<el-button type="primary" @click="dialogVisible = false"-->
          <!--&gt;确 定</el-button-->
        <!--&gt;-->
      <!--</span>-->
    </el-dialog>
  </div>
</template>
<script>
import {mapActions, mapGetters, mapMutations} from 'vuex';
import {apiQueryModulePublishMachine} from '@/api';
import pinyinMatch from 'pinyin-match';
import vueVirtualTable from 'vue-virtual-table';

export default {
  name: "viewPublish",
  components: {
    vueVirtualTable
  },
  props: {
    id: {
      type: String
    },
    moduleType: {
      type: Number
    }
  },
  data() {
    return {
      dialogVisible: false,
      machine_uuid_list: [],
      ex_machine_uuid_list: [],
      publishAll: false,
      searchBox: ""
    };
  },
  mounted() {
  },
  methods: {
    handleClose() {
      this.dialogVisible = false;
      this.ex_machine_uuid_list = [];
      this.machine_uuid_list = [];
      this.publishAll = false;
    },
    async queryPublishMachine() {
      try {
        const res = await apiQueryModulePublishMachine(
          this.id,
          this.moduleType
        );
        console.log(res);
        if (res.data.state_code === 0) {
          this.machine_uuid_list = res.data.data.machine_uuid_list;
          // this.machine_uuid_list = res.data.data.machine_uuid_list
          this.ex_machine_uuid_list = [];
          this.dialogVisible = true;
        } else if (res.data.state_code === 1) {
          // 无发布机器
          this.machine_uuid_list = [];
          this.ex_machine_uuid_list = [];
          this.dialogVisible = true;
          // this.machine_uuid_list = res.data.data.machine_uuid_list
        } else if (res.data.state_code === 2) {
          // 全部餐厅
          this.publishAll = true;
          this.machine_uuid_list = res.data.data.machine_uuid_list;
          this.ex_machine_uuid_list = res.data.data.ex_machine_uuid_list;
          this.dialogVisible = true;
        } else {
          throw new Error(res.data.error_msg);
        }
      } catch (e) {
        this.$message.error("查询失败" + e.message);
        this.machine_uuid_list = [];
        this.ex_machine_uuid_list = [];
      }
    },
    ...mapMutations(["setSubTitle"]),
    ...mapActions([])
  },
  computed: {
    ...mapGetters(["allMachineList"]),
    _machine_uuid_list() {
      // const list =
      let list = [];
      if (this.publishAll === true) {
        list = this.$_.differenceWith(
          this.allMachineList,
          this.machine_uuid_list,
          (leftVal, rightVal) => leftVal.machine_uuid === rightVal
        );
      } else {
        list = this.$_.intersectionWith(
          this.allMachineList,
          this.machine_uuid_list,
          (leftVal, rightVal) => leftVal.machine_uuid === rightVal
        );
      }
      list = this.$_.sortBy(list, "label_task_day_ts", "desc");
      const searchText = this.searchBox;
      if (searchText) {
        list = list.filter(a => {
          const canteen = a.eatery_name + "," + a.canteen_name;
          let res = pinyinMatch.match(canteen, searchText);
          // console.log(res);
          return res.length > 0;
        });
      }
      return list;
    },
    tableConfig() {
      return [
        {
          prop: "eatery_name",
          name: "食堂名称"
        },
        {
          prop: "canteen_name",
          name: "餐厅名称"
        },
        {
          prop: "machine_name",
          name: "机器名称"
        },
        {
          prop: "machine_id",
          name: "机器ID"
        }
      ];
    }
  },
  watch: {}
};
</script>
<style></style>
